import { render, staticRenderFns } from "./admin-permission.vue?vue&type=template&id=21fb9bba&scoped=true"
import script from "./admin-permission.vue?vue&type=script&lang=js"
export * from "./admin-permission.vue?vue&type=script&lang=js"
import style0 from "./admin-permission.vue?vue&type=style&index=0&id=21fb9bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb9bba",
  null
  
)

export default component.exports